import { fetchWithSupabaseAuth } from "./supabaseClient.js";

export const EPI_QUESTIONS_CHANGED_EVENT = "grain:epi-questions-changed";

async function assistantRequest(path, { method = "GET", body } = {}) {
  const response = await fetchWithSupabaseAuth(`/api/assistant${path}`, {
    method, cache: "no-store",
    ...(body === undefined ? {} : { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = payload?.detail;
    const error = new Error(typeof detail === "string" ? detail : detail?.message || "Lumi est indisponible pour le moment.");
    error.status = response.status;
    error.code = detail?.code;
    throw error;
  }
  return payload;
}

export const fetchEpiStatus = () => assistantRequest("/status");
export const fetchEpiSettings = () => assistantRequest("/settings");
export const refreshEpiModels = () => assistantRequest("/settings/models/refresh", { method: "POST" });
export const saveEpiSettings = (options) => assistantRequest("/settings", { method: "PUT", body: options });
async function updateQuestions(path, options) {
  try {
    return await assistantRequest(path, options);
  } finally {
    // Même un échec de Lumi peut avoir enregistré une question à examiner.
    if (typeof window !== "undefined") window.dispatchEvent(new Event(EPI_QUESTIONS_CHANGED_EVENT));
  }
}

export const askEpi = (question, context, previousQuestionIds = []) => updateQuestions("/ask", {
  method: "POST", body: { question, context, previous_question_ids: previousQuestionIds.slice(-8) },
});
export const sendEpiFeedback = (id, value) => updateQuestions(`/questions/${encodeURIComponent(id)}/feedback`, { method: "POST", body: { value } });
export const fetchEpiQuestions = ({ view = "all", page = 1, pageSize = 25 } = {}) => (
  assistantRequest(`/questions?view=${view}&page=${page}&page_size=${pageSize}`)
);
// La capture passe par l'API (droit « Utiliser Lumi ») : une balise <img> n'enverrait pas la connexion.
export async function fetchEpiCapture(url) {
  const response = await fetchWithSupabaseAuth(url, { cache: "force-cache" });
  if (!response.ok) throw new Error("Capture du Guide indisponible.");
  return URL.createObjectURL(await response.blob());
}

async function fetchDocumentFile(path, format, fallbackName) {
  const response = await fetchWithSupabaseAuth(`/api/assistant${path}?format=${encodeURIComponent(format)}`, { cache: "no-store" });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(typeof payload?.detail === "string" ? payload.detail : payload?.detail?.message || "Ce guide n'est plus disponible.");
  }
  return { blob: await response.blob(), filename: /filename="([^"]+)"/.exec(response.headers.get("Content-Disposition") || "")?.[1] || `${fallbackName}.${format}` };
}

export const fetchEpiDocument = (id, format) => fetchDocumentFile(`/questions/${encodeURIComponent(id)}/document`, format, "guide-lumi");
// Guides prêts de la page : parcours approuvés, téléchargés tels quels, sans question à Lumi.
export const fetchEpiReadyGuides = (page) => assistantRequest(`/ready-guides?page=${encodeURIComponent(page)}`);
export const fetchEpiReadyGuideDocument = (slug, format) => fetchDocumentFile(`/ready-guides/${encodeURIComponent(slug)}/document`, format, `guide-${slug}`);
export const resolveEpiQuestion =(id) => assistantRequest(`/questions/${encodeURIComponent(id)}/resolve`, { method: "POST" });
